import React from "react";
import { Carousel, Col, Container, Row } from "react-bootstrap";
import pro1p1 from "../../images/project1-p1.png";
import pro1p2 from "../../images/project1-p2.png";
import pro1p3 from "../../images/project1-p3.png";
import pro2p1 from "../../images/project2-p1.png";
import pro2p2 from "../../images/project2-p2.png";
import pro2p3 from "../../images/project2-p3.png";
import pro3p1 from "../../images/project3-p1.png";
import pro3p2 from "../../images/project3-p2.png";
import pro3p3 from "../../images/project3-p3.png";

const Portfolio = () => {
  return (
    <Container className="font mt-5 mb-5">
      <h1 className="text-center  ">
        My <span className="heading">Portfolio</span>
      </h1>
      <Container className=" mt-5 p-5 project-bg project-container border border-4 border-info rounded  ">
        <Row>
          <Col sm={12} md={6} lg={6}>
            <h2 className="fw-bold">Cool Cars Bd</h2>
            <h5 className="text-secondary">
              It is a Car buying Website. On this website, you can search for
              your desire car and can see the description of the spectacular
              car. Here are more facilities for a user.{" "}
            </h5>

            <li>
              Users can place orders, see his orders, and give a review. Admin
              can see all orders of users
            </li>
            <li>
              Admin can add a new car and make a new admin by providing the new
              admin’s email.
            </li>
            <li>
              Users can place orders, see his orders, and give a review. Admin
              can see all orders of users.
            </li>
            <h5 className="mt-2">
              Frontend:{" "}
              <span>
                {" "}
                <span className="badge bg-info m-1">HTML 5</span>
                <span className="badge bg-info">CSS3</span>
                <span className="badge bg-info m-1 ">Bootstrap</span>
                <span className="badge bg-info">React.js</span>
                <span className="badge bg-info m-1">JavaScript(ES6)</span>
                <span className="badge bg-info m-1">React Router</span>
              </span>{" "}
            </h5>
            <h5 className="mt-2">
              Backend:
              <span>
                {" "}
                <span className="badge bg-info m-1">MongoDB</span>
                <span className="badge bg-info">Express.js</span>
              </span>{" "}
            </h5>

            <h5>
              Link:{" "}
              <span>
                <a
                  className="link-btn badge bg-info m-1"
                  href="https://algo-digital.web.app/ "
                  target="_blank"
                  rel="noreferrer"
                >
                  Live
                </a>
                <a
                  className="link-btn badge bg-info m-1"
                  href="https://github.com/moshiur01/algo-digital-client-side"
                  target="_blank"
                  rel="noreferrer"
                >
                  Client Side
                </a>
                <a
                  className="link-btn badge bg-info m-1"
                  href="https://github.com/moshiur01/algo-digital-server-side"
                  target="_blank"
                  rel="noreferrer"
                >
                  Server Side
                </a>
              </span>{" "}
            </h5>
          </Col>
          <Col sm={12} md={6} lg={6} className="my-auto">
            <Carousel className=" carousel-img  border rounded  border-3 border-info ">
              <Carousel.Item interval={1000}>
                <img
                  className="d-block w-100 img-fluid "
                  src={pro1p1}
                  alt="First slide"
                />
              </Carousel.Item>
              <Carousel.Item interval={500}>
                <img
                  className="d-block w-100 img-fluid"
                  src={pro1p2}
                  alt="Second slide"
                />
              </Carousel.Item>
              <Carousel.Item interval={1000}>
                <img
                  className="d-block w-100 img-fluid"
                  src={pro1p3}
                  alt="Third slide"
                />
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>
      </Container>
      <Container className=" mt-5 p-5 project-bg project-container border border-4 border-info rounded  ">
        <Row>
          <Col sm={12} md={6} lg={6}>
            <h2 className="fw-bold">Travel Bizz</h2>
            <h5 className="text-secondary">
              It is a Tourism Website. On this website, a user can book a Tour
              place to enjoy his vacation. Beside a user can read latest tour
              blogs. Here are more facilities for a user{" "}
            </h5>

            <li>
              Users and Admin can sign up and log in to this website using
              google or Email and password
            </li>
            <li>Admin can maintain the orders of users.</li>
            <li>
              Users can place booking, see his booking, and delete his booking.
            </li>
            <h5 className="mt-2">
              Frontend:{" "}
              <span>
                {" "}
                <span className="badge bg-info m-1">HTML 5</span>
                <span className="badge bg-info">CSS3</span>
                <span className="badge bg-info m-1 ">Bootstrap</span>
                <span className="badge bg-info">React.js</span>
                <span className="badge bg-info m-1">JavaScript(ES6)</span>
                <span className="badge bg-info m-1">React Router</span>
              </span>{" "}
            </h5>
            <h5 className="mt-2">
              Backend:
              <span>
                {" "}
                <span className="badge bg-info m-1">MongoDB</span>
                <span className="badge bg-info">Express.js</span>
              </span>{" "}
            </h5>

            <h5>
              Link:{" "}
              <span>
                <a
                  className="link-btn badge bg-info m-1"
                  href="https://travel-bizz.web.app/ "
                  target="_blank"
                  rel="noreferrer"
                >
                  Live
                </a>
                <a
                  className="link-btn badge bg-info m-1"
                  href="https://github.com/moshiur01/travel-bizz-client-side"
                  target="_blank"
                  rel="noreferrer"
                >
                  Client Side
                </a>
                <a
                  className="link-btn badge bg-info m-1"
                  href="https://github.com/moshiur01/travel-bizz-server-side-"
                  target="_blank"
                  rel="noreferrer"
                >
                  Server Side
                </a>
              </span>{" "}
            </h5>
          </Col>
          <Col sm={12} md={6} lg={6} className="my-auto">
            <Carousel className=" carousel-img  border rounded  border-3 border-info ">
              <Carousel.Item interval={1000}>
                <img
                  className="d-block w-100 img-fluid "
                  src={pro2p1}
                  alt="First slide"
                />
              </Carousel.Item>
              <Carousel.Item interval={500}>
                <img
                  className="d-block w-100 img-fluid"
                  src={pro2p2}
                  alt="Second slide"
                />
              </Carousel.Item>
              <Carousel.Item interval={1000}>
                <img
                  className="d-block w-100 img-fluid"
                  src={pro2p3}
                  alt="Third slide"
                />
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>
      </Container>
      <Container className=" mt-5 p-5 project-bg project-container border border-4 border-info rounded  ">
        <Row>
          <Col sm={12} md={6} lg={6}>
            <h2 className="fw-bold">Star HealthCare BD</h2>
            <h5 className="text-secondary">
              It is a website where a patient can easily get treatment for his
              desired disease. A user can select his service according to his
              disease. Moreover a user can read latest health related news. Here
              are more facilities for a user.{" "}
            </h5>

            <li>User can login or Sign up with Email and Password.</li>
            <li>
              A user can book, see and delete a service according to his
              disease.
            </li>
            <li>User can only login After Email Verification</li>
            <h5 className="mt-2">
              Frontend:{" "}
              <span>
                {" "}
                <span className="badge bg-info m-1">HTML 5</span>
                <span className="badge bg-info">CSS3</span>
                <span className="badge bg-info m-1 ">Bootstrap</span>
                <span className="badge bg-info">React.js</span>
                <span className="badge bg-info m-1">JavaScript(ES6)</span>
                <span className="badge bg-info m-1">React Router</span>
              </span>{" "}
            </h5>

            <h5>
              Link:{" "}
              <span>
                <a
                  className="link-btn badge bg-info m-1"
                  href="https://star-healthcare-bd.web.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Live
                </a>
                <a
                  className="link-btn badge bg-info m-1"
                  href="https://github.com/moshiur01/Star-HealthCare-BD"
                  target="_blank"
                  rel="noreferrer"
                >
                  Client Side
                </a>
              </span>{" "}
            </h5>
          </Col>
          <Col sm={12} md={6} lg={6} className="my-auto">
            <Carousel className=" carousel-img  border rounded  border-3 border-info ">
              <Carousel.Item interval={1000}>
                <img
                  className="d-block w-100 img-fluid "
                  src={pro3p1}
                  alt="First slide"
                />
              </Carousel.Item>
              <Carousel.Item interval={500}>
                <img
                  className="d-block w-100 img-fluid"
                  src={pro3p2}
                  alt="Second slide"
                />
              </Carousel.Item>
              <Carousel.Item interval={1000}>
                <img
                  className="d-block w-100 img-fluid"
                  src={pro3p3}
                  alt="Third slide"
                />
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Portfolio;
